<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import BaaS from 'minapp-sdk'

export default {
  name: 'App',
  created () {
    BaaS.init('d7b0c63a71501f015c1a')
    if (!localStorage.getItem('ifx_baas_auth_token')) {
      BaaS.auth.anonymousLogin().then(user => {
        // console.log(user)
      }).catch(err => {
        // HError
        console.log(err)
      })
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue